import React from 'react';

const Navigation = ({ isOpen, onToggle, onNavigate }) => {
  const navLinks = [
    { href: '#home', label: 'Home' },
    { href: '#inventory', label: 'Inventory' },
    { href: '#about', label: 'About Us' },
    { href: '#services', label: 'Services' },
    { href: '#testimonials', label: 'Testimonials' },
    { href: '#contact', label: 'Contact' }
  ];

  const handleNavClick = (e, href) => {
    e.preventDefault();
    if (onToggle) onToggle();
    if (onNavigate) onNavigate(href);
  };

  return (
    <>
      <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
        {navLinks.map((link) => (
          <li key={link.href}>
            <a 
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
      <button 
        className="mobile-menu-btn" 
        onClick={onToggle}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </>
  );
};

export default Navigation;
